import { createBaseApi } from '../baseApi';

export const userApi = createBaseApi('userApi').injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contact form.
     *
     * Sends ONLY the raw form fields. The subject, recipient and HTML body are
     * built server-side. Do not point this back at `email-service/send`, which
     * accepts a client-supplied `to` and raw `html` and is therefore locked to
     * internal callers only.
     *
     * Expected payload:
     *   { firstname, lastname, email, message, website, renderedAt }
     *   - `website`    honeypot; must stay empty
     *   - `renderedAt` epoch ms the form mounted; used as a bot time trap
     */
    sendContactMessage: builder.mutation({
      query: (contactData) => ({
        url: 'email-service/contact',
        method: 'POST',
        body: contactData
      })
    }),
  }),
});

export const { useSendContactMessageMutation } = userApi;
